import http from './http'

export function getLoggedInUser() {
  return http.get("/v1/profile/me", { withCredentials: true })
}

export function uploadImage(property, file) {
  var formData = new FormData()
  formData.append('upload', file)
  formData.append('property', property)
  return http.post("/v1/upload/image", formData, { headers: { 'Content-Type': 'multipart/form-data' }, withCredentials: true})
}

export function getMembers() {
  return http.get("/v1/profile/members", { withCredentials: true })
}

export function createMember(member) {
  return http.post("/v1/profile/members", { member }, { withCredentials: true })
}
